import { render, staticRenderFns } from "./EduExercise.vue?vue&type=template&id=1ee304e6&scoped=true&"
import script from "./EduExercise.vue?vue&type=script&lang=js&"
export * from "./EduExercise.vue?vue&type=script&lang=js&"
import style0 from "./EduExercise.vue?vue&type=style&index=0&id=1ee304e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee304e6",
  null
  
)

export default component.exports